import { Component, EventEmitter, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PersonRoleEnum } from '../../Models/OtherClasses';
import { ConfigService } from '../../Services/ConfigService';
import { AuthService } from '../../RoutingAuth/auth.service';
import { Subscription } from 'rxjs';


@Component({ 
	selector: 'SettingsShell',
	templateUrl: 'SettingsShell.html',
	
})
export class SettingsShellComponent implements OnInit, OnDestroy {

	
	constructor(
		private authService: AuthService,
		public configData: ConfigService,
		private myRouter: Router
	) {

	}

	subscription: Subscription;

	sizeEmitter = new EventEmitter<number>();
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.sizeEmitter.next(window.innerWidth);
	}
	toggleShow() {
		this.showMenu = !this.showMenu;
		this.configData.setSavedSetting('showmenu', 'settingsshell', this.showMenu);
	}
	showMenu = true;
	isAdmin = false;
	isSuperAdmin = false;
	ngOnInit() {
		this.subscription = this.authService.authNavStatus$.subscribe((status: boolean) => {
			this.loadData();
		});
		this.loadData();
		
		this.showMenu = window.innerWidth > 992 || this.configData.getSavedSetting('showmenu', 'settingsshell');
		this.sizeEmitter.subscribe(width => {
			this.showMenu = width > 992 || this.showMenu;
		})
	}
	loadData() {
		this.isAdmin = this.configData.IsUserInRole(PersonRoleEnum.ADMIN);
		this.isSuperAdmin = this.configData.IsUserInRole(PersonRoleEnum.SUPERADMIN);
		if (!this.isAdmin) {
			this.myRouter.navigate(['ang', 'Settings', 'Company', this.configData.companyID]);
		}
	}
	ngOnDestroy() {
		// prevent memory leak when component is destroyed
		if (this.subscription) {
			this.subscription.unsubscribe();
		}

	}

}
